export default __webpack_public_path__ + "static/media/google_logo.66ae25be.svg";